export function getValueAtPath(data: unknown, field: string): unknown {
  return field.split(".").reduce((acc, curr) => {
    if (acc == null) return undefined;
    return (acc as Record<string, unknown>)[curr];
  }, data);
}
